import { useState, forwardRef } from 'react';
import { Picture } from '@ui';
import { useKeenSlider } from 'keen-slider/react';
import ArrowCircle from '@components/Carousel/components/ArrowCircle';
import useWindowSize from '@customHooks/useWindowSize';
import { SMART_APP_LINK } from '@constants/appLinks';
import {
  // oysterBarPromotionNew7,
  // coffeeBanner,
  // barMenuOktoberfestBannerNew,
  // barMenuCrabFestivalBanner,
  // barMenuCoffeeWithFocacho,
  barMenuSevernoeMenuBanner,
  barMenuMorskoyEzhBanner
} from '@images';
import { Link } from '@compat/router';
import './styles.scss';
import { twcls } from '@utils/twcls';

export const weeklyPromosBanners = [
  {
    id: 14,
    image: barMenuMorskoyEzhBanner,
    title: 'Фестиваль морского ежа',
    to: null
  },
  {
    id: 13,
    image: barMenuSevernoeMenuBanner,
    title: 'Северное меню',
    to: null
  }
  // {
  //   id: 12,
  //   image: barMenuOktoberfestBannerNew,
  //   title: 'Октоберфест',
  //   to: null
  // },
  // {
  //   id: 9,
  //   image: barMenuCoffeeWithFocacho,
  //   title: 'Кофе с Фокаччо',
  //   to: null
  // },
  // { id: 8, image: coffeeBanner, title: 'Акция 7', to: '/news/608' },
  // { id: 7, image: oysterBarPromotionNew7, title: 'Акция 7', to: null }
  // { id: 1, image: oysterBarPromotion4, title: 'Акция 1', to: null },
  // { id: 2, image: oysterBarPromotion5, title: 'Акция 5', to: null },
  // { id: 3, image: barMenuPonedelnikBannerNew, title: 'Акция 2', to: null },
  // { id: 4, image: barMenuVtornikBannerNew, title: 'Акция 3', to: null },
  // { id: 5, image: barMenuSredaBannerNew, title: 'Акция 4', to: null }
];

interface WeeklyPromosProps {
  isShop?: boolean;
  className?: string;
}

const WeeklyPromos = forwardRef<HTMLElement, WeeklyPromosProps>(
  ({ isShop, className }, ref) => {
    const [_currentSlide, setCurrentSlide] = useState(0);
    const { windowWidth, isMobile } = useWindowSize();

    const [sliderRef, instanceRef] = useKeenSlider({
      slides: {
        perView: 'auto',
        spacing: 20
      },
      loop: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      }
    });

    const nextSlide = (): void => {
      instanceRef.current?.next();
    };

    const prevSlide = (): void => {
      instanceRef.current?.prev();
    };

    const promotions = weeklyPromosBanners.filter(item => {
      if (isShop && [2, 3].includes(item.id)) {
        return false;
      }
      return true;
    });

    const handleSlideClick = (promotionId: number): void => {
      if (windowWidth <= 767 && promotionId === 1) {
        window.open(SMART_APP_LINK, '_blank');
      }
    };

    return (
      <section
        ref={ref}
        id='promos'
        className={twcls('weekly-promos', className)}
      >
        <div className='weekly-promos__container'>
          <div className='weekly-promos__header'>
            <h2 className='weekly-promos__title oysterbar-test-title-secondary'>
              Акции недели
            </h2>
          </div>

          <div className='weekly-promos__content'>
            {!isMobile && promotions?.length > 1 && (
              <div className='arrow-circle-container'>
                <ArrowCircle
                  left
                  onClick={e => {
                    e.stopPropagation();
                    prevSlide();
                  }}
                />
                <ArrowCircle
                  onClick={e => {
                    e.stopPropagation();
                    nextSlide();
                  }}
                />
              </div>
            )}
            <div ref={sliderRef} className='keen-slider weekly-promos__slider'>
              {promotions.map(promotion => {
                if (promotion.to) {
                  return (
                    <Link
                      key={promotion.id}
                      to={promotion.to}
                      className='cursor-pointer keen-slider__slide weekly-promos__slide'
                      onClick={() => {
                        handleSlideClick(promotion.id);
                      }}
                    >
                      <Picture icon={promotion.image} />
                    </Link>
                  );
                }
                return (
                  <div
                    key={promotion.id}
                    className='keen-slider__slide weekly-promos__slide'
                    onClick={() => {
                      handleSlideClick(promotion.id);
                    }}
                    style={{
                      cursor:
                        windowWidth <= 767 && promotion.id === 1
                          ? 'pointer'
                          : 'default'
                    }}
                  >
                    <Picture icon={promotion.image} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    );
  }
);

export default WeeklyPromos;
